export class DataCatalogPipelineViolation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineViolation.attributeTypeMap;
    }
    constructor() {
    }
}
